import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../lib/auth.js';

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { admin, isLoading } = useAuth();
  const location = useLocation();
  if (isLoading) return null;
  if (!admin) return <Navigate to="/login" replace state={{ from: location }} />;
  return <>{children}</>;
}
